<template>
  <div class="container">
    <div class="left-panel">
      <div class="posts">
        <div v-for="post in posts" :key="post.id" class="post">
          <div class="post-header">
            <img class="profile-image" src="https://www.w3schools.com/w3images/avatar1.png" alt="Profile Image">
            <strong v-if="post.is_anonymous == 1">{{ $t('anonymous') }}</strong>
            <strong v-else>{{ post.username }}</strong>
            <span class="timestamp">{{ formatDate(post.timestamp) }}</span>
          </div>
          <p>{{ post.content }}</p>
          <div class="badges">
            <span class="badge">{{ $t(`allCountry.${post.country}`, post.country) }}</span>
            <span class="badgeTheme">{{ $t(`allTheme.${post.theme}`, post.theme) }}</span>
          </div>
          <!-- Nouveau bouton Partager -->
          <button class="download-post-btn" style="right: 40px !important;" @click.stop="openShareMenu(post, $event)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="18" cy="5" r="3"></circle>
              <circle cx="6" cy="12" r="3"></circle>
              <circle cx="18" cy="19" r="3"></circle>
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
            </svg>
          </button>
          <!-- Ajoutez ce bouton -->
          <button class="download-post-btn" @click.stop="downloadPost(post)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
          </button>
          <div class="reactions">
            <button v-for="(emoji, key) in reactionTypes" :key="key" @click.stop="handleReaction(post, key)"
              :class="['reaction-btn', { active: hasReacted(post.id, key) }]">
              {{ emoji }} {{ post.reactions?.[key] || 0 }}
            </button>
          </div>

          <div @click="closeShareMenu" v-if="activeSharePost !== null" class="share-menu-overlay"></div>
          <!-- Ajoutez ce menu de partage -->
          <div v-if="activeSharePost == post.id" class="share-menu">
            <button @click="shareOnSocial('twitter', post)">
              <img src="https://cdn-icons-png.flaticon.com/512/733/733579.png" alt="Twitter" width="20"> Twitter
            </button>
            <button @click="shareOnSocial('facebook', post)">
              <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" width="20"> Facebook
            </button>
            <button @click="shareOnSocial('whatsapp', post)">
              <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="WhatsApp" width="20"> WhatsApp
            </button>
            <button @click="copyPostLink(post)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor"><!-- Icône lien --></svg>
              Copier le lien
            </button>
          </div>
        </div>
        <div ref="postsEnd" class="posts-end">
          <span v-if="loadingMore" class="posts-loading">…</span>
          <button v-else-if="hasMore" @click="loadPosts()" class="load-more-btn">{{ $t('loadMore') }}</button>
        </div>
      </div>
      <button @click="openPopup" class="add-post-btn">+</button>
    </div>

    <div class="right-panel">
      <h2>{{ $t('filter') }}</h2>
      <div class="filters">
        <select v-model="selectedCountry">
          <option value="0">{{ $t('countries') }}</option>
          <option v-for="country in countries" :key="country.id" :value="country.id">
            {{ $t(`allCountry.${country.name}`, country.name) }}
            ({{ country.usage_count }})
          </option>
        </select>

        <select v-model="selectedTheme">
          <option value="0">{{ $t('themes') }}</option>
          <option v-for="theme in themes" :key="theme.id" :value="theme.id">
            {{ $t(`allTheme.${theme.name}`, theme.name) }}

            ({{ theme.usage_count }})
          </option>
        </select>
      </div>

      <p>{{ $t('map') }}</p>

      <div id="">
        <MapComponent :posts="mapPoints" :key="map" />
      </div>

      <div class="language-selector">
        <div class="selected-language" @click="toggleDropdown">
          <img :src="languages[selectedLanguage].flag" :alt="languages[selectedLanguage].name" width="24" height="16">
          {{ languages[selectedLanguage].name }}
        </div>
        <div v-if="showDropdown" :class="['dropdown', dropdownClass]">
          <div v-for="(lang, key) in languages" :key="key" @click="changeLanguage(key)" class="dropdown-item">
            <img :src="lang.flag" :alt="lang.name" width="24" height="16"> {{ lang.name }}
          </div>
        </div>
      </div>

    </div>

    <div v-if="isPopupVisible" class="popup-overlay">
      <div class="popup">
        <h3>{{ $t('expression') }}</h3>
        <div class="input-group">
          <input v-model="data.username" :disabled="data.isAnonymous" :placeholder="$t('name')" />
          <label>
            <input type="checkbox" v-model="data.isAnonymous" /> {{ $t('anonymous') }}
          </label>
        </div>
        <select v-model="data.country">
          <option value="" disabled>{{ $t('country') }}</option>
          <option v-for="country in countries" :key="country.id" :value="country.id">
            {{ $t(`allCountry.${country.name}`, country.name) }}
          </option>
        </select>
        <select v-model="data.theme">
          <option value="" disabled>{{ $t('category') }}</option>
          <option v-for="theme in themes" :key="theme.id" :value="theme.id">{{ $t(`allTheme.${theme.name}`,
            theme.name) }}</option>
        </select>
        <textarea v-model="data.content" :placeholder="$t('content')"></textarea>
        <button @click="submitPost" class="submit-btn">{{ $t('publish') }}</button>
        <button @click="closePopup" class="cancel-btn">{{ $t('cancel') }}</button>
      </div>

    </div>
  </div>
</template>

<script>
import apiService, { PAGE_SIZE } from '@/services/apiService';
import moment from 'moment';
import MapComponent from './components/MapComponent.vue';

import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
const notyf = new Notyf();


export default {
  name: 'HomePage',
  data() {
    return {
      posts: [],
      mapPoints: [],
      hasMore: true,
      loadingMore: false,
      reactionTypes: {
        fire: '🔥',
        heart: '❤️',
        rage: '😡'
      },
      data: {
        theme: "",
        country: "",
        username: "Anonyme",
        content: "",
        isAnonymous: false
      },
      selectedLanguage: this.$i18n.locale,
      languages: {
        en: { name: "En", flag: "https://flagcdn.com/w40/gb.png" },
        fr: { name: "Fr", flag: "https://flagcdn.com/w40/fr.png" },
        es: { name: "Es", flag: "https://flagcdn.com/w40/es.png" },
        de: { name: "De", flag: "https://flagcdn.com/w40/de.png" },
        it: { name: "It", flag: "https://flagcdn.com/w40/it.png" },
        pt: { name: "Pt", flag: "https://flagcdn.com/w40/pt.png" },
        nl: { name: "Nl", flag: "https://flagcdn.com/w40/nl.png" },
        ja: { name: "Ja", flag: "https://flagcdn.com/w40/jp.png" },
      },
      countries: [],
      themes: [],
      selectedCountry: "0",
      selectedTheme: "0",
      newPostContent: '',
      dropdownClass: '',
      me: null,
      map: 0,
      isPopupVisible: false,
      showDropdown: false,
      // pour le partage
      activeSharePost: null,
      shareMenuStyle: {}
    };
  },
  components: {
    MapComponent
  },

  async mounted() {
    const userLanguage = navigator.language.split('-')[0];
    const lang = localStorage.getItem('language') || userLanguage;
    this.selectedLanguage = lang;

    // SEO Title
    document.title = "Cry4Change - Exprimez-vous";

    // SEO Meta Description
    let descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", "Exprimez vos idées, vos frustrations et vos rêves avec Cry4Change. Un espace où chaque voix compte et où le changement commence par un simple cri.");
    } else {
      descriptionMetaTag = document.createElement('meta');
      descriptionMetaTag.name = "description";
      descriptionMetaTag.content = "Exprimez vos idées, vos frustrations et vos rêves avec Cry4Change. Un espace où chaque voix compte et où le changement commence par un simple cri.";
      document.head.appendChild(descriptionMetaTag);
    }

    // Open Graph (OG) Meta Tags for Facebook and WhatsApp
    let ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.content = "Cry4Change - Exprimez-vous";
    document.head.appendChild(ogTitle);

    let ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    ogDescription.content = "Exprimez vos idées, vos frustrations et vos rêves avec Cry4Change. Un espace où chaque voix compte et où le changement commence par un simple cri.";
    document.head.appendChild(ogDescription);

    let ogImage = document.createElement('meta');
    ogImage.setAttribute('property', 'og:image');
    ogImage.content = require('@/assets/logo.png');
    document.head.appendChild(ogImage);

    let ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    ogUrl.content = window.location.href;
    document.head.appendChild(ogUrl);

    let ogType = document.createElement('meta');
    ogType.setAttribute('property', 'og:type');
    ogType.content = "website";
    document.head.appendChild(ogType);

    // Twitter Card Meta Tags
    let twitterCard = document.createElement('meta');
    twitterCard.setAttribute('name', 'twitter:card');
    // twitterCard.content = "summary_large_image";
    twitterCard.content = require('@/assets/logo.png');
    document.head.appendChild(twitterCard);

    let twitterTitle = document.createElement('meta');
    twitterTitle.setAttribute('name', 'twitter:title');
    twitterTitle.content = "Cry4Change - Exprimez-vous";
    document.head.appendChild(twitterTitle);

    let twitterDescription = document.createElement('meta');
    twitterDescription.setAttribute('name', 'twitter:description');
    twitterDescription.content = "Exprimez vos idées, vos frustrations et vos rêves avec Cry4Change. Un espace où chaque voix compte et où le changement commence par un simple cri.";
    document.head.appendChild(twitterDescription);

    let twitterImage = document.createElement('meta');
    twitterImage.setAttribute('name', 'twitter:image');
    twitterImage.content = require('@/assets/logo.png');
    document.head.appendChild(twitterImage);
    // FIN SEO

    // Écouter les nouveaux posts en temps réel
    this.stopListening = apiService.onNewPost(() => this.loadNewestPosts());

    // Première page du fil (réactions incluses par l'API), carte et filtres en parallèle
    const [countries, themes, mapPoints] = await Promise.all([
      apiService.getCountries(),
      apiService.getThemes(),
      apiService.getMapPoints(),
      this.loadPosts(true),
    ]);
    this.countries = countries;
    this.themes = themes;
    this.mapPoints = mapPoints;
    this.map = this.map + 1;

    // Charger la page suivante quand on arrive en bas du fil
    if ('IntersectionObserver' in window && this.$refs.postsEnd) {
      this.endObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) this.loadPosts();
      }, { rootMargin: '600px' });
      this.endObserver.observe(this.$refs.postsEnd);
    }

    this.me = await apiService.getLastMe() || null;
    // initialiser l'ajout
    this.data.country = this.me?.country_id || ""
    this.data.theme = this.me?.theme_id || ""
  },
  beforeUnmount() {
    if (this.endObserver) this.endObserver.disconnect();
    if (this.stopListening) this.stopListening();
  },
  methods: {
    isFiltered() {
      return this.selectedCountry != "0" || this.selectedTheme != "0";
    },
    fetchPage(before) {
      return this.isFiltered()
        ? apiService.getPostsByQuery(this.selectedCountry, this.selectedTheme, before)
        : apiService.getPosts(before);
    },
    // reset = repartir de la première page (au chargement ou quand les filtres changent)
    async loadPosts(reset = false) {
      if (!reset && (this.loadingMore || !this.hasMore)) return;
      const token = this.loadToken = (this.loadToken || 0) + 1;
      this.loadingMore = true;
      const last = this.posts[this.posts.length - 1];
      let page = [];
      try {
        page = await this.fetchPage(reset || !last ? 0 : last.id);
      } catch (error) {
        page = [];
      }
      if (token !== this.loadToken) return; // un chargement plus récent a pris le relais
      this.posts = reset ? page : this.posts.concat(page);
      this.hasMore = page.length === PAGE_SIZE;
      this.loadingMore = false;
    },
    // Ajoute en haut du fil les posts publiés depuis le dernier chargement
    async loadNewestPosts() {
      let page = [];
      try {
        page = await this.fetchPage(0);
      } catch (error) {
        return;
      }
      const newestId = this.posts[0]?.id || 0;
      const fresh = page.filter(post => post.id > newestId);
      if (fresh.length) this.posts = fresh.concat(this.posts);
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;

      // Vérifie la position de la liste pour savoir s'il faut ouvrir en haut ou en bas
      this.$nextTick(() => {
        const selector = this.$el.querySelector('.selected-language');
        const rect = selector.getBoundingClientRect();
        const spaceAbove = rect.top; // Espace disponible en haut
        const spaceBelow = window.innerHeight - rect.bottom; // Espace disponible en bas

        // Si l'espace au-dessus est plus grand que celui en bas, on ouvre le dropdown vers le haut
        if (spaceAbove > spaceBelow) {
          this.dropdownClass = 'open-up';
        } else {
          this.dropdownClass = '';
        }
      });
    },
    openPopup() {
      this.isPopupVisible = true;
    },
    closePopup() {
      this.isPopupVisible = false;
      this.data = {
        theme: "",
        country: "",
        username: "Anonyme",
        content: "",
        isAnonymous: false
      };
    },
    formatDate(date) {
      return moment(date).fromNow();
    },
    changeLanguage(lang) {
      this.selectedLanguage = lang;
      this.$i18n.locale = this.selectedLanguage;
      localStorage.setItem('language', lang);
      this.showDropdown = false;
    },
    toggleReaction(postIndex, reaction) {
      const post = this.posts[postIndex];
      if (!post.reactionCounts[reaction]) {
        this.$set(post.reactionCounts, reaction, 1);
      } else {
        post.reactionCounts[reaction]++;
      }
    },
    hasReacted(postId, reaction) {
      const key = `c4c_reaction_${postId}_${reaction}`;
      return localStorage.getItem(key) === '1';
    },

    async handleReaction(post, reaction) {
      const key = `c4c_reaction_${post.id}_${reaction}`;
      const alreadyReacted = localStorage.getItem(key) === '1';
      const action = alreadyReacted ? 'remove' : 'add';

      // Optimistic update
      if (!post.reactions) post.reactions = { fire: 0, heart: 0, rage: 0 };
      post.reactions[reaction] = Math.max(
        0,
        (post.reactions[reaction] || 0) + (action === 'add' ? 1 : -1)
      );

      // Màj localStorage
      if (action === 'add') {
        localStorage.setItem(key, '1');
      } else {
        localStorage.removeItem(key);
      }

      // Appel API
      const updated = await apiService.toggleReaction(post.id, reaction, action);
      if (updated) post.reactions = updated;
    },
    async submitPost() {
      if (this.data.country != "" && this.data.theme != "" && this.data.content.trim()) {
        try {
          const postData = {
            country: this.data.country,
            theme: this.data.theme,
            username: this.data.username,
            content: this.data.content,
            isAnonymous: this.data.isAnonymous
          };

          try {
            await apiService.submitPost(postData);
            await this.loadNewestPosts();
          } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
              notyf.error({
                message: error.response.data.error,
                duration: 5000
              });
            } else {
              notyf.error({
                message: 'Une erreur est survenue, veuillez réessayer plus tard.',
                duration: 5000
              });
            }
          }
          this.closePopup();
        } catch (error) {
          console.error('Erreur lors de la soumission:', error);
        }
      } else {
        console.error('Tous les champs doivent être remplis');
      }
    },
    async downloadPost(post) {
      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.left = '-9999px';
      iframe.style.visibility = 'hidden';
      iframe.style.width = '500px';
      iframe.style.height = '500px';
      document.body.appendChild(iframe);

      try {
        const doc = iframe.contentDocument || iframe.contentWindow.document;

        doc.open();
        doc.write(`
        <!DOCTYPE html>
        <html lang="fr">
        <head>
          <meta charset="UTF-8" />
          <title>Cry4Change - Témoignage</title>
          <style>
            * { 
              margin: 0; 
              padding: 0; 
              box-sizing: border-box; 
              font-family: 'Arial', sans-serif;
            }
            
            body {
              background-color: #121212;
              color: #f0f0f0;
              height: 500px;
              width: 500px;
              position: relative;
              overflow: hidden;
              margin: 0;
              padding: 30px;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              border: 15px solid #1d1d1b;
            }
            
            .header {
              display: flex;
              align-items: center;
              margin-bottom: 30px;
            }
            
            .icon {
              font-size: 28px;
              margin-right: 15px;
              color: #e03a3a;
            }
            
            .post-info {
              font-size: 14px;
              color: #aaa;
            }
            
            .content {
              font-size: 20px;
              line-height: 1.6;
              margin-bottom: 30px;
              padding: 20px;
              background: rgba(30, 30, 30, 0.7);
              border-left: 3px solid #e03a3a;
            }
            
            .footer {
              position: absolute;
              bottom: 30px;
              left: 0;
              width: 100%;
              padding: 0 30px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            
            .country {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #aaa;
            }
            
            .country-icon {
              margin-right: 5px;
              font-size: 16px;
            }
            
            .signature {
              font-size: 14px;
              color: #e03a3a;
              font-weight: bold;
            }
            
            .theme {
              background: #e03a3a;
              color: white;
              padding: 3px 8px;
              border-radius: 3px;
              font-size: 12px;
              margin-top: 10px;
              display: inline-block;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="icon">📢</div>
            <div class="post-info">
              <div>${post.is_anonymous == 1 ? this.$t('anonymous') : post.username}</div>
              <div class="theme">${this.$t(`allTheme.${post.theme}`, post.theme)}</div>
            </div>
          </div>
          
          <div class="content">
            ${post.content.replace(/\n/g, '<br>')}
          </div>
          
          <div class="footer">
            <div class="country">
              <span class="country-icon">📍</span>
              ${this.$t(`allCountry.${post.country}`, post.country)}
            </div>
            <div class="signature">cry4change.com</div>
          </div>
        </body>
        </html>
      `);
        doc.close();

        await new Promise(resolve => setTimeout(resolve, 200));

        const html2canvas = await import('html2canvas');
        const canvas = await html2canvas.default(iframe.contentDocument.body, {
          width: 500,
          height: 500,
          scale: 1,
          logging: false,
          useCORS: true,
          backgroundColor: '#121212',
          allowTaint: true,
          foreignObjectRendering: true
        });

        const link = document.createElement('a');
        link.download = `cry4change-post-${post.id}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();

      } catch (error) {
        console.error("Erreur:", error);
        notyf.error("Erreur lors de la génération de l'image");
      } finally {
        document.body.removeChild(iframe);
      }
    },
    // POUR PARTAGER LIMAGE
    openShareMenu(post, event) {
      this.activeSharePost = post.id;
      console.log("act", post.id)

      // Positionnement du menu
      this.$nextTick(() => {
        const buttonRect = event.target.getBoundingClientRect();
        this.shareMenuStyle = {
          bottom: `${window.innerHeight - buttonRect.top + 5}px`,
          right: `${window.innerWidth - buttonRect.right}px`
        };
      });
    },

    closeShareMenu() {
      this.activeSharePost = null;
    },

    async shareOnSocial(platform, post) {
      try {
        const postUrl = `${window.location.origin}/post/${post.id}`
        const text = `${post.content.substring(0, 100)}${post.content.length > 100 ? '...' : ''}\n\nVoir plus sur Cry4Change: `

        switch (platform) {
          case 'twitter':
            window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(postUrl)}`, '_blank')
            break
          case 'facebook':
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}`, '_blank')
            break
          case 'whatsapp':
            window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + postUrl)}`, '_blank')
            break
        }
      } catch (error) {
        console.error("Erreur de partage:", error)
        notyf.error("Erreur lors du partage")
      }
    },

    async copyPostLink(post) {
      const url = `${window.location.origin}/post/${post.id}`;
      try {
        await navigator.clipboard.writeText(url);
        notyf.success('Lien copié dans le presse-papier');
      } catch (err) {
        notyf.error('Échec de la copie du lien');
      }
      this.closeShareMenu();
    },
    async generatePostImage(post) {
      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.left = '-9999px';
      iframe.style.visibility = 'hidden';
      iframe.style.width = '500px';
      iframe.style.height = '500px';
      document.body.appendChild(iframe);

      try {
        const doc = iframe.contentDocument || iframe.contentWindow.document;

        doc.open();
        doc.write(`
        <!DOCTYPE html>
        <html lang="fr">
        <head>
          <meta charset="UTF-8" />
          <title>Cry4Change - Témoignage</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Arial', sans-serif; }
            body {
              background-color: #121212;
              color: #f0f0f0;
              height: 500px;
              width: 500px;
              position: relative;
              overflow: hidden;
              margin: 0;
              padding: 30px;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              border: 15px solid #1d1d1b;
            }
            .header { display: flex; align-items: center; margin-bottom: 30px; }
            .icon { font-size: 28px; margin-right: 15px; color: #e03a3a; }
            .post-info { font-size: 14px; color: #aaa; }
            .content {
              font-size: 20px;
              line-height: 1.6;
              margin-bottom: 30px;
              padding: 20px;
              background: rgba(30, 30, 30, 0.7);
              border-left: 3px solid #e03a3a;
            }
            .footer {
              position: absolute;
              bottom: 30px;
              left: 0;
              width: 100%;
              padding: 0 30px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .country { display: flex; align-items: center; font-size: 14px; color: #aaa; }
            .country-icon { margin-right: 5px; font-size: 16px; }
            .signature { font-size: 14px; color: #e03a3a; font-weight: bold; }
            .theme {
              background: #e03a3a;
              color: white;
              padding: 3px 8px;
              border-radius: 3px;
              font-size: 12px;
              margin-top: 10px;
              display: inline-block;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="icon">📢</div>
            <div class="post-info">
              <div>${post.is_anonymous == 1 ? this.$t('anonymous') : post.username}</div>
              <div class="theme">${this.$t(`allTheme.${post.theme}`, post.theme)}</div>
            </div>
          </div>
          <div class="content">
            ${post.content.replace(/\n/g, '<br>')}
          </div>
          <div class="footer">
            <div class="country">
              <span class="country-icon">📍</span>
              ${this.$t(`allCountry.${post.country}`, post.country)}
            </div>
            <div class="signature">cry4change.com</div>
          </div>
        </body>
        </html>
      `);
        doc.close();

        // Attendre que le contenu soit chargé
        await new Promise(resolve => setTimeout(resolve, 200));

        const html2canvas = await import('html2canvas');
        const canvas = await html2canvas.default(iframe.contentDocument.body, {
          width: 500,
          height: 500,
          scale: 1,
          logging: false,
          useCORS: true,
          backgroundColor: '#121212',
          allowTaint: true,
          foreignObjectRendering: true
        });

        return canvas.toDataURL('image/png');
      } catch (error) {
        console.error("Erreur:", error);
        notyf.error("Erreur lors de la génération de l'image");
        return '';
      } finally {
        document.body.removeChild(iframe);
      }
    }
  },
  watch: {
    selectedCountry() {
      this.loadPosts(true);
    },
    selectedTheme() {
      this.loadPosts(true);
    }
  },
};
</script>

<style scoped>
.posts-end {
  display: flex;
  justify-content: center;
  padding: 16px 0 24px;
}

.load-more-btn {
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 20px;
  padding: 8px 18px;
  cursor: pointer;
  font-size: 14px;
}

.load-more-btn:hover {
  background: #e0e0e0;
}

.posts-loading {
  color: #888;
  font-size: 20px;
  letter-spacing: 2px;
}

.reactions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.reaction-btn {
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 20px;
  padding: 4px 10px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.reaction-btn:hover {
  background: #e0e0e0;
  transform: scale(1.05);
}

.reaction-btn.active {
  background: #ffe0e0;
  border-color: #e03a3a;
  color: #e03a3a;
  font-weight: bold;
}
</style>
